
import { defineComponent } from 'vue';
import { $api } from '../common/apiService';
import { Trip } from '@/Models/Trip';
import TripTimelineItem from '@/components/TripTimelineItem.vue';

export default defineComponent({
  name: 'PastTripsPage',
  components: { TripTimelineItem },
  data() {
    return {
      pastTrips: [] as Trip[],
    };
  },
  async mounted() {
    const trips = await $api.trips.fetch();
    if (trips) {
      const today = new Date();
      this.pastTrips = trips.filter(t => new Date(t.startDate) < today);
    }
  },
});
